<template>
    <div>
        <!-- 左按钮 -->
        <button class="switch-btn left-btn" @click="prev" :disabled="mainProjectIndex === 0">
            ←
        </button>
        <!-- 右按钮 -->
        <button class="switch-btn right-btn" @click="next" :disabled="mainProjectIndex === mainProjects.length - 1">
            →
        </button>

        <!-- 高陵文体中心 -->
        <div class="content" v-if="mainProjectIndex==0">
            <div class="title">
                <div class="icon"> </div>
                <h1>高陵文体中心项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-left" style="margin-top: 5em;width:24em;">
                    高陵文体中心位于西安市高陵区通远街道，总占地面积356亩，建筑面积约19.4万平方米，总投资21.22亿元。中心由六大功能单体组成，包括体育场、体育馆、运动员招待所、会议中心、商业设施以及文化图书馆。该项目是渭北地区目前建设规模最大、业态最为丰富的文化体育综合中心，集赛事举办、全民健身、会议会展、文化休闲和商业服务等多功能于一体。</p>
                <img src="../../../../../assets/img/case/shangye/shangye_wentizhongxin.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/shangye/shangye_wentizhongxin.png" class="company-img"></img></p>
            <p>
                体育场总建筑面积约5757平方米，为7500座丙级体育场，可承办足球、田径等多项体育赛事，周边还配建有乒乓球场、网球场等多样化户外运动设施。体育馆建筑面积约4万平方米，设5883座席，符合乙级场馆标准，内含篮球馆、羽毛球馆以及8泳道标准游泳池，具备举办地区性和全国单项比赛的条件。运动员招待所拥有266间客房，并配备全日制餐厅等配套功能，为赛事及活动提供完善的接待服务。会议中心设13间规格不同的会议室，可满足各类政务、商务会议需求。商业文化图书馆则融合阅读、餐饮与购物功能，为市民提供多元文化体验。配套设施方面，项目建有两层地下人防车库，提供超过1200个车位，地面辅以景观绿化与水系工程，营造出宜人舒适的公共环境。
            </p>
            <p>作为高陵区乃至渭北区域的重要民生工程，高陵文体中心不仅显著提升了本地文体设施水平，也为促进全民健身、丰富群众文化生活和承接各类赛事会展活动提供了高标准平台。</p>
        </div>

        <!-- 安康江华城项目 -->
        <div class="content" v-if="mainProjectIndex==1">
            <div class="title">
                <div class="icon"> </div>
                <h1>安康江华城项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-left" style="margin-top: 5em;width:18em;">
                    安康江华城位于陕西省安康市汉滨区兴安中路88号，总建筑面积59964㎡，占地9551㎡，是安康市目前规模较大、业态较为丰富的商住综合体项目，其商业自开业以来已成为安康市民和游客休闲、购物、餐饮、娱乐的重要地标。</p>
                <img src="../../../../../assets/img/case/shangye/shangye_jianghuacheng.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/shangye/shangye_jianghuacheng.png" class="company-img"></img></p>
            <p>
                商业综合体作为城市的“能耗巨人”，高昂的能耗不仅显著增加了运营成本，还成为实现可持续发展目标的关键制约因素。将节能改造视为一项战略投资，正成为领先商业体的共识。本项目采用高标准集成化暖通空调方案，全面覆盖室内通风、舒适空调、智能防排烟及全套电控系统。我们致力于以一体化的精工设计，为客户营造健康、宜人且节能的卓越室内环境。同时，项目核心能源中心——包括高效制冷机房、现代化锅炉房及节能冷却塔系统——为其提供从设备供应、专业安装到配电自控的“一站式”交钥匙工程。
            </p>
        </div>
        
        <foot-img-carousel type="shangye" :projects="otherProjects" @change="showProjectDetail"></foot-img-carousel>
    </div>
</template>

<script>
import footImgCarousel from './footImgCarousel.vue';
export default{
    components:{
        footImgCarousel
    },
    data(){
        return {
            mainProjectIndex:0,
            mainProjects: [
                {
                    cover: "wentizhongxin",
                    title: "高陵创想小镇·文体中心项目",
                    hasDetail:true
                },
                {
                    cover: "jianghuacheng",
                    title: "安康江华城项目",
                    hasDetail:true
                }
            ],
            otherProjects:[
                {
                    cover: "lanzhouxizhan",
                    title: "兰州西站BAS系统"
                },
                {
                    cover: "xinhua",
                    title: "陕西新华发行集团西北出版物物流配送中心智能化系统工程"
                },
                {
                    cover: "yicuiyuan",
                    title: "逸翠园一期、二期、三期智能化系统维保及改造"
                },
                {
                    cover: "yujincheng",
                    title: "御锦城三期、四期智能化系统"
                },
                {
                    cover: "yangling",
                    title: "杨凌国际会展中心D馆项目"
                },
                {
                    cover: "zhongzidasha",
                    title: "杨凌种子大厦多联机空调系统"
                },
                {
                    cover: "shanxishengwei",
                    title: "陕西省委办公楼弱电系统                             "
                },
                {
                    cover: "zhongche",
                    title: "中车永济电机研发楼智能化样板项目"
                }
            ]
        }
    },
    methods:{
        showProjectDetail(index) {
            this.mainProjectIndex =index
        },
        prev() {
            if (this.mainProjectIndex > 0) this.mainProjectIndex--;
        },
        next() {
            if (this.mainProjectIndex < this.mainProjects.length - 1) this.mainProjectIndex++;
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>